import { addMinutes, format, isBefore, isEqual } from "date-fns";

const formatTimeRange = (start, end) =>
  `${format(start, "HH:mm")} - ${format(end, "HH:mm")}`;

const createTimeSlot = (start, durationMinutes) => {
  const end = addMinutes(start, durationMinutes);

  return {
    start,
    end,
    formattedRange: formatTimeRange(start, end),
  };
};

const isValidSlot = (slot, timeRange) => {
  return (
    isBefore(slot.end, timeRange.latestEnd) ||
    isEqual(slot.end, timeRange.latestEnd)
  );
};

export const generateTimeSlots = (timeRange, is5minsAppointment) => {
  const SLOT_DURATION_MINUTES = is5minsAppointment ? 5 : 15;

  const totalMinutes =
    (timeRange.latestEnd.getTime() - timeRange.earliestStart.getTime()) /
    (1000 * 60);
  const numberOfSlots = Math.floor(totalMinutes / SLOT_DURATION_MINUTES) + 1;

  return Array.from({ length: numberOfSlots }, (_, index) => {
    const start = addMinutes(
      timeRange.earliestStart,
      index * SLOT_DURATION_MINUTES
    );
    return createTimeSlot(start, SLOT_DURATION_MINUTES);
  }).filter((slot) => isValidSlot(slot, timeRange));
};
